import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-invigilatoradmin',
  templateUrl: './invigilatoradmin.component.html',
  styleUrls: ['./invigilatoradmin.component.css']
})
export class InvigilatoradminComponent implements OnInit {

  loginForm: any;
  submitted = false;
  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      mobileno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
    });

  }


  get l() {
    return this.loginForm.controls;
  }

  public eri_status_admin: any;
  onSubmitLogin() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.submitted = false;
    // this.bool_intruc_main = false;
    // this.bool_issue_type = true;
    //this.form3 = true;
    //this.formDetail3 = true;


    this.api
      .checkLogin(this.loginForm.value)
      .subscribe((result: any) => {

        var result_var = result['message'];
        console.log(result)
        window.localStorage.setItem('email', result.email)
        window.localStorage.setItem('mobile', result.mobile)

        if (result_var == 'No data Found') {
          alert("Please Login with valid Credentials");
          return;
        }
        else {
          this.api
            .checknotifyLogin(this.loginForm.value)
            .subscribe((result: any) => {
              console.log("checknotifyLogin : " + JSON.stringify(result))
              this.eri_status_admin = result;
            });
          window.localStorage.setItem('invigilator_logged_in', "TRUE");
          this.router.navigateByUrl('/invigilator_dashboard/invigiericount');

          console.log(JSON.stringify(result));
          // this.invigilator_name = result.name;
          // this.invigilator_role = result.role;
          // var eri = result;

          // this.eriForm.state = result.State;
          // this.mail_single = result.email;
          // this.state_single = result.State;
          // this.district_single = result.district;
          // this.iticode_single = result.iticode;

          //console.log(result.State);
          //console.log(result.district);
          //console.log(result.iticode);


          var eri_iticode = {
            iticode: result.iticode
          };


          // this.api.eriiticode(eri_iticode).subscribe((result: any) => {

          //   this.trade_single = result;
          // });


        }

      });

  }
  omit_number(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  omit_email(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 45 || k == 46 || k == 64 || k == 95 || k == 32);
  }

}
